import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const queryCheckRegistrationNumber = (registrationNumber, enabled) => {
    return {
        queryKey: [ORGANIZATION.COMPANY_INFO.queryKey, registrationNumber],
        queryFn: async () => {
            const response = await client.get(
                replaceParameters(ORGANIZATION.COMPANY_INFO.url, { registrationNumber })
            );
            return response.data;
        },
        enabled: enabled
    };
};

export default queryCheckRegistrationNumber;